@if (advancedLocation && advancedFilters) {
<div class="left-panel">
  <form [formGroup]="formGroup">
    <div class="datepicker">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [disabled]="loadingHops" placeholder="Start date" (dateInput)="startDateInput($event)" [value]="defaultStart" readonly="readonly" />
          <input matEndDate [disabled]="loadingHops" placeholder="End date" (dateInput)="endDateInput($event)" [value]="defaultEnd" readonly="readonly" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker" (click)="clearPicker()"></mat-datepicker-toggle>
        <mat-date-range-picker #picker (closed)="dateChange($event)"></mat-date-range-picker>
      </mat-form-field>
    </div>

    <mat-form-field class="full-width" appearance="fill">
      <mat-label>LAC</mat-label>
      <input matInput class="form-control" formControlName="LACSearchControl" placeholder="LAC..." type="string" id="lac" name="lac" (keyup.enter)="searchLocation()" />
    </mat-form-field>

    <mat-form-field class="full-width" appearance="fill">
      <mat-label>Cell ID</mat-label>
      <input
        matInput
        class="form-control"
        formControlName="CellIDSearchControl"
        placeholder="Cell ID..."
        type="string"
        id="cellid"
        name="cellid"
        (keyup.enter)="searchLocation()"
      />
    </mat-form-field>

    @if (isMikrotik) {
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>Operator</mat-label>
      <input
        matInput
        class="form-control"
        formControlName="OperatorControl"
        placeholder="Operator..."
        type="string"
        id="operator"
        name="operator"
        (keyup.enter)="searchLocation()"
      />
    </mat-form-field>
    } @if (!isMikrotik) {
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>MCC</mat-label>
      <input matInput class="form-control" formControlName="MCCSearchControl" placeholder="MCC..." type="string" id="mcc" name="mcc" (keyup.enter)="searchLocation()" />
    </mat-form-field>
    } @if (!isMikrotik) {
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>MNC</mat-label>
      <input matInput class="form-control" formControlName="MNCSearchControl" placeholder="MNC..." type="string" id="mcc" name="mcc" (keyup.enter)="searchLocation()" />
    </mat-form-field>
    }

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Max Hops</mat-label>
      <input
        matInput
        class="form-control"
        formControlName="MaxHopControl"
        required
        placeholder="1..1000"
        type="number"
        id="maxhop"
        name="maxhops"
        (keyup.enter)="searchLocation()"
      />
      @if (formGroup.get('MaxHopControl').errors && formGroup.get('MaxHopControl').hasError('required')) {
      <mat-error>Enter a valid amount of maximum hops</mat-error>
      } @if ( formGroup.get('MaxHopControl').errors && (formGroup.get('MaxHopControl').hasError('min') || formGroup.get('MaxHopControl').hasError('max')) ) {
      <mat-error>Min: 1 | Max: 10000</mat-error>
      }
    </mat-form-field>

    @if (!isMikrotik) {
    <div class="distinctTowerToggle" [hidden]="true">
      <mat-label>Distinct Towers</mat-label>
      <mat-slide-toggle slot="start" [checked]="formGroup.get('DistinctTowerControl').value" (click)="toggleDistinctTowers()"></mat-slide-toggle>
    </div>
    }
  </form>
  <br />
  @if (loadingHops) {
  <div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <br />
  </div>
  }
  <div>
    <button mat-button (click)="searchLocation()" class="center" size="medium" expand="block" color="primary" fill="solid" style="background-color: #0f074b; color: white; margin-left: 10px; width: 200px;">APPLY FILTERS</button>
  </div>
</div>
}

<div [ngClass]="{ 'right-panel': !!advancedLocation && advancedFilters }">
  <div class="map-container">
    @if (showHops) {
    <div class="hop-details">
      @if (jumps != null && jumps.length <= 1) {
      <div>
        <huge-row>
          <p>No Movement History Found</p>
        </huge-row>
      </div>
      } @if (jumps != null && jumps.length > 1) {
      <div>
        @for (jump of jumps; track jump; let i = $index) {
        <huge-row>
          <span style="width: 25px">{{ i + 1 }}:</span>
          @if (i == 0) {
          <span> {{ jump.to }}</span>
          } @if (i == jumps.length - 1) {
          <span>{{ jump.from }}</span>
          } @if (i > 0 && i < jumps.length - 1) {
          <span>{{ jump.from }} &#8594; {{ jump.to }} - {{ jump.time }}</span>
          }
        </huge-row>
        }
      </div>
      }
    </div>
    }
    <div [hidden]="!(!locationClusters || locationClusters.length == 0)">
      <br />
      <br />
      <br />
      <p class="text-center">No location data to display</p>
    </div>
    <div style="position: relative; overflow: hidden">
      @if (locationClusters && locationClusters.length > 0) {
      <div #mapContainer id="map" class="{{ config?.Fullscreen ? 'max-map' : 'min-map' }}"></div>
      <div class="my-legend">
        <div class="legend-scale">
          <ul class="legend-labels">
            <li><span style="border-radius: 25px; background: #7edc52"></span>First Tower Location</li>
            <li><span style="border-radius: 25px; background: #fb5253"></span>Current Tower Location</li>
            <li><span style="border-radius: 25px; background: #da70d6"></span>Previous Tower Location</li>
            <li><span style="border-radius: 25px; background: white"></span>Tower Location</li>
          </ul>
        </div>
      </div>
      <div class="network-legend">
        <div class="legend-scale">
          <ul class="legend-labels">
            <li><span style="border-top: 6px solid #000000"></span>Cell C</li>
            <li><span style="border-top: 6px solid #f3db00"></span>MTN</li>
            <li><span style="border-top: 6px solid #166bce"></span>Telkom</li>
            <li><span style="border-top: 6px solid #eb1900"></span>Vodacom</li>
            <li><span style="border-top: 6px solid #666666"></span>Other</li>
          </ul>
        </div>
      </div>
      <!-- <ion-toolbar
				class="map-pagination-controls"
				*ngIf="LocationTracingEnabled && hopData && hopData.length > 0"> -->
      <div slot="primary">
        <button mat-button [disabled]="true"> Hop: {{ hopData[CurrentTraceIndex] != null ? hopData[CurrentTraceIndex].label : 'N/A' }} </button>
        <button mat-button [disabled]="true"> Tower: {{ hopData[CurrentTraceIndex] != null ? hopData[CurrentTraceIndex].towerlabel : 'N/A' }} </button>
        <button mat-button [disabled]="CurrentTraceIndex <= 0" (click)="NextLocationTrace()">
          <mat-icon slot="icon-only">arrow_back</mat-icon>
        </button>
        <button mat-button [disabled]="CurrentTraceIndex >= TotalTraceIndex" (click)="PreviousLocationTrace()">
          <mat-icon slot="icon-only">arrow_forward</mat-icon>
        </button>
      </div>
      }
      <!-- </ion-toolbar> -->
      @if (advancedLocation && !isMikrotik) {
      <div id="map-type-control">
        <div class="map-controls">
          <mat-list>
            <h3 style="font-size: 13pt; font-weight: bold">Map Options</h3>
            <mat-list-item>
              <mat-checkbox
                [checked]="showSignalStrengths"
                [disabled]="hopData == null || hopData.length == 0"
                (ionChange)="showSignalStrengths = !showSignalStrengths; toggleAllSignalStrength(showSignalStrengths)"
                color="dark"
                slot="start"
              ></mat-checkbox>
              <mat-label>Show All Signals</mat-label>
            </mat-list-item>
            <mat-list-item>
              <mat-checkbox
                [checked]="showRingfences"
                [disabled]="hopData == null || hopData.length == 0"
                (ionChange)="showRingfences = !showRingfences; toggleAllRingfence(showRingfences)"
                color="dark"
                slot="start"
              ></mat-checkbox>
              <mat-label>Show All Ringfences</mat-label>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
      }
    </div>
    @if (!disableAdvanced) {
    <div class="mapActions">
      @if (!LocationTracingEnabled) {
      <button mat-button (click)="toggleAdvancedLocationHistory()" class="pull-right" style="background-color: #c96d00; margin-left: 10px;">{{
        advancedLocation ? 'BACK TO DETAILS' : 'ADVANCED'
      }}</button>
      } @if (advancedLocation && !LocationTracingEnabled) {
      <button mat-button (click)="toggleFilters()" class="pull-right" style="background-color: #c96d00; margin-left: 10px;">{{
        advancedFilters ? 'HIDE FILTERS' : 'SHOW FILTERS'
      }}</button>
      } @if (advancedLocation) {
      <button mat-button (click)="toggleLocationTracing()" class="pull-right" size="small" expand="block" color="primary" fill="solid" style="background-color: #0f074b; color: white; margin-left: 10px;"
        >{{ LocationTracingEnabled ? 'END ' : 'START ' }} BACKTRACE</button
      >
      }
    </div>
    }
  </div>
</div>

@if (advancedLocation) {
<div style="display: inline-block" class="full-width">
  @if (!loadingHops) {
  <span>
    <app-chip-filter
      class="filter"
      [savedSearch]="hopsSearch"
      [filterOptions]="hopFilterOptions"
      [filterChips]="hopFilterChips"
      (searchSubmit)="submitHopSearch($event)"
      (chipsSortToggled)="hopSortToggled()"
      (filtersCleared)="hopsFiltersCleared()"
    >
    </app-chip-filter>

    <ng-template #affixTemplate let-row>
      <app-card-table-actions [row]="row" [actions]="hopRowActions" [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
    </ng-template>

    @if (filteredHopData != null && filteredHopData.length > 0) {
    <app-card-table
      #HopTable
      [tableHeaders]="isMikrotik ? mikrotikHeaders : headers"
      [currentPage]="currentHopsPage"
      [data]="filteredHopData"
      [totalItems]="hopData.length"
      [options]="isMikrotik ? mikrotikHopsTableOptions : hopsTableOptions"
      (rowSelectedEvent)="rowSelected($event)"
      [enableInfiteScroll]="false"
      [enableTablePagination]="true"
      [affixTemplate]="affixTemplate"
      (paginateEvent)="paginateHops($event)"
      [breakpoint]="ScreenSize.TABLET"
    >
    </app-card-table>
    } @if (!filteredHopData || filteredHopData.length == 0) {
    <p class="text-align-center">No results were found.</p>
    }

    <ng-template #sticky> </ng-template>
  </span>
  }
</div>
}
